import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import { ILink } from 'tbk-components/src/components/Button';
import { nl2br } from '../../lib/nl2br';

export interface IAlternatingItemProps {
	title?: string;
	/**
	 * @control textarea
	 */
	text?: string;
	image?: IImage;
	imageUnformatted?: boolean;
	showLink?: boolean;
	link?: ILink;
	showBullets?: boolean;
	bullets?: string[];
}

export interface IAlternatingTextAndImagesProps extends IBaseElementProps {
	alternatingItems?: IAlternatingItemProps[];
}

/**
 * Alternating Text and Images
 * @block
 * @requiresHooks
 * @icon id
 */
const AlternatingTextAndImages: React.FC<IAlternatingTextAndImagesProps> = ({
	alternatingItems = [],
	className,
	classNames = [],
}) => (
	<div
		className={
			className ||
			cn('alternating-text-and-images', 'container', ...classNames)
		}
	>
		<div className="alternating-text-and-images__container container-fluid">
			{alternatingItems.length > 0 && (
				<>
					{alternatingItems.map((item, index) => (
						<div key={index} className="image-and-content row">
							{item.image && (
								<div
									className={
										className ||
											cn(
												'image-and-content__image col-12 col-lg-6',
												item.imageUnformatted && 'image-and-content__image--unformatted',
											)
									}
								>
									<Image {...item.image} />
								</div>
							)}
							<div className="image-and-content__content col-12 col-lg-6">
								<div className="image-and-content__content-inner">
									{item.title && <h2>{item.title}</h2>}
									{item.text && <p>{nl2br(item.text)}</p>}
									{item.link && item.showLink && (
										<a
											className="image-and-content__link"
											href={item.link.href}
											target={item.link.target}
										>
											{item.link.label}
										</a>
									)}
									{item.bullets &&
										item.bullets.length &&
										item.showBullets && (
											<ul>
												{item.bullets.map(
													(bullet, bIndex) => (
														<li
															key={bIndex}
															dangerouslySetInnerHTML={{
																__html: bullet,
															}}
														/>
													),
												)}
											</ul>
										)}
								</div>
							</div>
						</div>
					))}
				</>
			)}
		</div>
	</div>
);

export default AlternatingTextAndImages;
